const table111 = [
    {
        key: "entity_code",
        name: "法人コード",
        editable: false
    },
    {
        key: "entity_name",
        name: "法人名",
        editable: false
    },
    {
        key: "row_number",
        name: "行番号",
        editable: false
    },
    {
        key: "current_period_deduction",
        name: "当期の減(2)",
        editable: false
    },
    {
        key: "current_period_addition",
        name: "当期の増(3)",
        editable: false
    },
    {
        key: "capital_end",
        name: "期末資本金または資本準備金",
        editable: true
    },
    {
        key: "capital_begin",
        name: "期首資本金または資本準備金",
        editable: true
    }
];

export { table111 };
